import { entityTypes } from '../../static/types/objectType';
import { initialManagerState } from '../../static/types/objectInitialState';
import { initialIndividualState } from '../../static/initialState/commonInitialState/individualInitialState';
import { initialLegalEntityState } from '../../static/initialState/commonInitialState/legalEntityInitalState';
import { ReducedManagerType } from '../../static/types/commonTypes/reducedManagerType';
import ReducedIndividualPerson from './ReducedIndividualPerson';
import ReducedLegalEntity from './ReducedLegalEntity';
import useAppContext from '../../hooks/useAppContext';
import { AppContextType } from '../../context/AppContext';
import { initialReducedManagerState } from '../../static/initialState/commonInitialState/initialReducedManagerState';

type ReducedManagerListProps = {
    checked: boolean,
    reducedManagers: ReducedManagerType[],
    addButtonText: string,
    removeButtonText: string,
    labelItem?: string,
    draftFieldName?: string,
    setReducedManagers: ( reducedManagers: ReducedManagerType[] ) => void
    setReducedManagersValidity: ( isValid: boolean ) => void
}

export default function ReducedManagerList({
    checked,
    reducedManagers,
    labelItem,
    setReducedManagers,
    addButtonText,
    removeButtonText,
    draftFieldName = 'ReducedManagerList',
    setReducedManagersValidity
}: ReducedManagerListProps) {

    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }
    let listValidity: boolean[] = [ false ]

    const addManager = () => {
        setReducedManagers([
            ...reducedManagers,
            initialManagerState
        ]);

        listValidity.push( false )
        let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName ]: [
            ...reducedManagers,
            initialReducedManagerState
        ]}
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const removeLastManager = () => {
        if (reducedManagers.length > 1) {
            setReducedManagers(reducedManagers.slice(0, -1));
            let draft = parseDraft()
            const tempDraft = { ...draft, [ draftFieldName ]: reducedManagers.slice(0, -1)}
            setDraftFormData( stringifyDraft( tempDraft ))
        }
        if (listValidity.length > 1) {
            listValidity.slice(0, -1)
        }
    };

    const updateManager = (index: number, updatedManager: ReducedManagerType) => {
        const newManagers = [...reducedManagers];
        newManagers[index] = updatedManager;
        setReducedManagers(newManagers);
        let draft = parseDraft()
        const tempDraft = { ...draft, [ draftFieldName ]: newManagers }
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const toggleManagerType = ( person: "Personne physique" | "Personne morale", index: number) => {

        const newManager: ReducedManagerType = person === "Personne physique"
        ? {
            person: "Personne physique", 
            personDetails: initialIndividualState
            } 
        : {
            person: "Personne morale", 
            entityDetails: initialLegalEntityState
            }
        
        updateManager(index, newManager);
    };

    const updateManagersValidity = (index: number, isValid: boolean) => {
        listValidity[index] = isValid;
        setReducedManagersValidity( listValidity.every( valid => valid ) );
    };

    return (
        <>
            <div className="mb-3 row">
                {
                    reducedManagers.map((manager, index) =>

                        <div key={index} className="tab-content mb-2">

                            <div className = "mb-3 row pt-3">

                                <div className = "mb-3 row">
                                    <div className = "col-sm-10">
                                        { labelItem ? <h6 className='text-bold'>{ `${labelItem} ${ index + 1 }` }</h6> : "" }
                                    </div>
                                </div>

                                <div className = "mb-3 row">

                                    <label htmlFor="personne" className = "col-sm-2 col-form-label">Personne</label>

                                    <div className = "col-sm-10">
                                        <select
                                            className = "form-select"
                                            id = "person"
                                            onChange = { e => toggleManagerType(
                                                e.target.value as "Personne physique" | "Personne morale",
                                                index
                                            ) }
                                            value = { manager?.person || "" }
                                        >
                                            {
                                                entityTypes.map( option => 
                                                    <option key = { option } value = { option }>
                                                        { option }
                                                    </option>
                                                )
                                            }
                                        </select>
                                    </div>

                                </div>
                            </div>

                            {
                                manager.person === "Personne physique"
                                ?
                                <ReducedIndividualPerson
                                    checked = { checked }
                                    onValidationChange = { (isValid: boolean) => updateManagersValidity( index, isValid ) }
                                    reducedIndividualPerson = { manager.personDetails } 
                                    changeReducedIndividualPerson= { details => {
                                        const updatedManager: ReducedManagerType = {
                                            ...manager,
                                            personDetails: { ...manager.personDetails, ...details }
                                        };
                                        updateManager( index, updatedManager );
                                    }}
                                />
                                : 
                                <ReducedLegalEntity
                                    checked = { checked }
                                    onValidationChange = { (isValid: boolean) => updateManagersValidity( index, isValid ) }
                                    reducedLegalEntity = { manager.entityDetails } 
                                    changeReducedLegalEntity = { details => {
                                        const updatedManager: ReducedManagerType = {
                                            ...manager,
                                            entityDetails: { ...manager.entityDetails, ...details }
                                        };
                                        updateManager( index, updatedManager );
                                    }}
                                />
                            }
                        </div>
                    )
                }
            </div>

        <div className="row mb-3">
            <div className="col d-flex justify-content-center align-items-center gap-5">
                <button type='button' onClick = { addManager }> {addButtonText} </button>
                { reducedManagers.length > 1 && <button type='button' onClick = { removeLastManager }> {removeButtonText} </button> }
            </div>
        </div>
    </>
  );
};